import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card } from '../Components/ui/card';
import { Button } from '../Components/ui/button';
import { CheckCircle, Home, Mail } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const ThankYou = () => {
  const { t } = useLanguage();
  const copy = t('thankYou');
  const navigate = useNavigate();

  // Scroll to top when component mounts
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleGoHome = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full">
        <Card className="p-8 text-center shadow-xl">
          {/* Success Icon */}
          <div className="flex justify-center mb-6">
            <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center">
              <CheckCircle className="w-12 h-12 text-green-600" />
            </div>
          </div>

          {/* Thank You Title */}
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            {copy.title}
          </h1>
          
          {/* Thank You Content */}
          <div className="text-lg text-gray-600 mb-8 space-y-4">
            <p>
              {copy.received}
            </p>
            <p>
              {copy.urgent}
            </p>
          </div>

          {/* Contact Information */}
          <div className="bg-gray-50 rounded-lg p-6 mb-8">
            <h3 className="text-xl font-semibold text-gray-900 mb-4">
              {copy.contact}
            </h3>
            <div className="space-y-3">
              <div className="flex items-center justify-center space-x-3">
                <Mail className="w-5 h-5 text-blue-600" />
                <span className="text-gray-700">info@intelevia.com</span>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              onClick={handleGoHome}
              className="flex items-center space-x-2 bg-blue-600 hover:bg-blue-700 text-white px-8 py-3 rounded-lg transition-colors"
            >
              <Home className="w-5 h-5" />
              <span>{copy.home}</span>
            </Button>
            
            <Button 
              onClick={() => window.history.back()}
              variant="outline"
              className="px-8 py-3 rounded-lg border-gray-300 text-gray-700 hover:bg-gray-50 transition-colors"
            >
              {copy.back}
            </Button>
          </div>

          {/* Additional Information */}
          <div className="mt-8 text-sm text-gray-500">
            <p>
              {copy.responseTime}
            </p>
            <p className="mt-1">
              {copy.thanks}
            </p>
          </div>
        </Card>
      </div>
    </div>
  );
};

export default ThankYou;
